var version = {
    "name":      "dativery",
    "buildDateCode": "20260823-123555",
    "buildDate": "Sun Aug 23 2026 12:35:55 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260823-123555",
    "backupUIVersion": "2.2.0-20250522-135037"
}
;
 export default version;